/**
 * O TEMA, claro ou escuro (19/10: "adicionar um alternador entre light/dark").
 *
 * Guardado no navegador (`localStorage`) e lido por quem quiser (a barra, que
 * tem o botão, e a moldura, que aplica o atributo na raiz). Vive fora do React
 * de propósito: o `index.html` o lê antes do primeiro quadro, e dois lugares
 * que mostram o mesmo botão (a barra e o menu do celular) têm de concordar.
 * O padrão é o escuro: é o tema do sistema.
 */
import { useSyncExternalStore } from "react";

export type Tema = "escuro" | "claro";
const CHAVE = "nectuno.tema";

function lido(): Tema {
  try {
    return localStorage.getItem(CHAVE) === "claro" ? "claro" : "escuro";
  } catch {
    return "escuro";
  }
}

let atual: Tema = lido();
const ouvintes = new Set<() => void>();

const assina = (f: () => void) => {
  ouvintes.add(f);
  return () => {
    ouvintes.delete(f);
  };
};

export function defineTema(novo: Tema) {
  atual = novo;
  try {
    localStorage.setItem(CHAVE, novo);
  } catch {
    /* sem armazenamento: o tema vale até recarregar */
  }
  ouvintes.forEach((f) => f());
}

export function useTema(): [Tema, (t: Tema) => void] {
  const tema = useSyncExternalStore(assina, () => atual, () => "escuro" as Tema);
  return [tema, defineTema];
}
